<era-panel>
  <era-panel-header>
    @if (group(); as currentGroup) {
      <era-title [isDetail]="true">
        <span title>Members of
          <span>{{ currentGroup.displayName }}</span>
        </span>
        <era-context-menu [isEditing]="editEnabled()"
                          (selectedEdit)="toggleEdit()"
                          canEdit="true">
          <button ngbDropdownItem
                  [routerLink]="['./permissions']">Permissions</button>
          <button ngbDropdownItem
                  (click)="addUser()">Add user</button>
          <button ngbDropdownItem
                  (click)="addGroup()">Add group</button>
        </era-context-menu>
      </era-title>
    }
  </era-panel-header>
  <era-security-member-list-group-items [isEditing]="editEnabled()"></era-security-member-list-group-items>
  <era-security-member-list-user-items [isEditing]="editEnabled()"></era-security-member-list-user-items>
</era-panel>